import { render, staticRenderFns } from "./FrequentShopperIcon.vue?vue&type=template&id=e7197ab0&"
import script from "./FrequentShopperIcon.vue?vue&type=script&lang=ts&"
export * from "./FrequentShopperIcon.vue?vue&type=script&lang=ts&"
import style0 from "./FrequentShopperIcon.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})


/* hot reload */
if (module.hot) {
  var api = require("c:\\source\\adViewer\\AdViewer.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e7197ab0')) {
      api.createRecord('e7197ab0', component.options)
    } else {
      api.reload('e7197ab0', component.options)
    }
    module.hot.accept("./FrequentShopperIcon.vue?vue&type=template&id=e7197ab0&", function () {
      api.rerender('e7197ab0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "wwwroot/src/components/FrequentShopperIcon.vue"
export default component.exports